export const CAPACITY_ROW_HEADER_ID = 'capacity-row-header';
